<app-progress-bar></app-progress-bar>
<section class="main-login up-down">
  <!-- Contenedor imagen y formulario -->
  <div class="login-container">
    <!-- Contenedor formulario-->
    <div class="login-container__content">
      <div class="login-container__content__title">
        <h5>{{ translatedTextKeyLogin.WELLCOME_TITTLE | translate }}</h5>
      </div>
      <div class="login-container__content__form">
        <form [formGroup]="form" class="login-form">
          <div class="login-form__buttons--networks">            
            <button
              class="login-form-2__sing-in-others"
              (click)="getAuthCode('Google')"
              pButton
            >
              <img
                src="../../../../../assets/images/icons/icons8-logo-de-google.svg"
                alt=""
              />
              {{ 'mcfLoginShell.signup.createAccountGoogle' | translate }}
            </button>
            <button
              class="login-form-2__sing-in-others"
              (click)="getAuthCode('Microsoft')"
              pButton
            >
              <img
                src="../../../../../assets/images/icons/ms-symbollockup_mssymbol_19.svg"
                alt=""
              />
              {{ 'mcfLoginShell.signup.createAccountMicrosoft' | translate }}
            </button>
            <button
              class="login-form-2__sing-in-others"
              (click)="goRegisterForm()"
              pButton
            >
              <i class="icon-mail"></i>
              {{ 'mcfLoginShell.signup.createAccountEmail' | translate }}
            </button>
          </div>
          <div class="link-login">
            {{ 'mcfLoginShell.signup.alreadyHaveAccount' | translate }}
            <a

              (click)="goBack()"
              class="login-form__buttons__link login-form__buttons__link--password"
              >{{ 'mcfLoginShell.signup.signIn' | translate }}</a
            >
          </div>
        </form>
      </div>
    </div>
    <!-- Contenedor imagen-->
    <div class="login-container__image">
      <img
        [src]="backgroundImage"
        alt="Argos ONE 2G Image"
      />
    </div>
  </div>
  <!-- Redes Sociales -->
<!--   <div class="social-media">
    <p class="social-media__text">{{mcfLoginShell.signup.followUsSocial | translate}}</p>
    <ul class="social-media__networks">
      <li class="social-media__networks__item">
        <a href="#" target="_blank">
          <i class="icon-twitter"></i>
        </a>
      </li>
      <li class="social-media__networks__item">
        <a href="#" target="_blank">
          <i class="icon-facebook"></i>
        </a>
      </li>
      <li class="social-media__networks__item">
        <a href="#" target="_blank">
          <i class="icon-instagram"></i>
        </a>
      </li>
    </ul>
  </div> -->
</section>
